import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import { materialTableLocalization } from "utils/materialTableLocalization";
import Api from "../../functions/Api";

export default function Roles() {
  const [ejecutaapi] = Api();
  const [data, setData] = useState([]);
  const [column] = useState([
    { title: "Estado", field: "ACTIVO", type: "boolean" },
    { title: "Nombre", field: "DESCRIPCION", type: "string" },
  ]);

  const traeRoles = () => {
    const body = JSON.stringify({ idRoles: -1 });
    ejecutaapi("obtieneroles", body).then(
      result => {
        if (result && result.Ok && result.result && result.result[0]) {
          setData(result.result[0]);
        }
      }
    );
  };

  useEffect(() => {
    traeRoles();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MaterialTable
      title="Catálogo de roles"
      columns={column}
      data={data}
      localization={materialTableLocalization}
    />
  );
}
